<!-- ═══════════════ FINANCIAL TERMINAL DATA TABLES ═══════════════ -->
<section class="max-w-[1320px] mx-auto px-6 lg:px-10 pb-12 lg:pb-16">
  <h3 class="font-display font-black text-2xl text-white uppercase tracking-wider text-center mb-10 lg:mb-12 flex flex-col items-center gap-4">
    Financial Terminal
    <span class="w-16 h-1 bg-gold rounded-full shadow-[0_0_10px_rgba(245,183,59,0.5)]"></span>
  </h3>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-6">

    <!-- Top Tokens Table -->
    <div class="card p-5.5 relative">
      <div class="flex items-center justify-between mb-5">
        <h3 class="font-display font-black text-[15.5px] uppercase tracking-wider text-white">Top Tokens</h3>
        <div class="flex bg-white/[0.02] p-0.5 rounded-lg border border-border-primary">
          <button (click)="state.tokenFilterTab.set('trending')" class="tab-btn"
            [class.active]="state.tokenFilterTab() === 'trending'">Trending</button>
        </div>
      </div>

      <div class="flex flex-col">
        @for (token of topTokens(); track token.symbol; let idx = $index) {
        <div class="table-row relative group">
          <div class="flex items-center gap-3">
            <span class="text-[11px] text-text-dim font-bold w-4">{{ idx + 1 }}</span>
            <div class="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-white/5 border border-white/10 shrink-0">
              <img *ngIf="token.logoUrl" [src]="token.logoUrl" [alt]="token.symbol" class="w-full h-full object-cover">
              <span *ngIf="!token.logoUrl" class="text-[11px] font-black text-white">{{ (token.symbol || '').charAt(0) || '?' }}</span>
            </div>
            <div>
              <span class="text-[13px] font-black text-white leading-none block">{{ token.symbol }}</span>
              <span class="text-[10px] text-text-dim mt-0.5 block">{{ token.name }}</span>
            </div>
          </div>
          <div class="flex items-center gap-3.5">
            <div class="text-right">
              <span class="text-[13px] font-bold text-white block">${{ (token.priceUsd < 0.1 ? (token.priceUsd | number:'1.5-5') : (token.priceUsd | number:'1.2-2')) || '0.00' }}</span>
              <span class="text-[10.5px] font-bold block" [class.text-emerald-400]="token.priceChange1d > 0"
                [class.text-rose-400]="token.priceChange1d < 0">{{ token.priceChange1d > 0 ? '+' : '' }}{{ (token.priceChange1d || 0).toFixed(2) }}%</span>
            </div>
          </div>
        </div>
        }
        @empty {
        <div class="py-8 text-center text-sm font-bold text-text-muted italic">
          No Stacking Cockpit Record Found
        </div>
        }
      </div>
    </div>



    <!-- Top Staking Table -->
    <div class="card p-5.5">
      <div class="flex items-center justify-between mb-5">
        <h3 class="font-display font-black text-[15.5px] uppercase tracking-wider text-white">Staking Cockpit</h3>
        <span (click)="state.selectTab('staking')"
          class="text-[12px] text-gold font-bold uppercase tracking-widest cursor-pointer hover:underline">View
          All</span>
      </div>

      <div class="flex flex-col">
        @for (pool of topStakingPools(); track pool.name) {
        <div class="table-row group" (click)="state.selectTab('staking')">
          <div class="flex items-center gap-3">
            <div class="w-8 h-8 rounded-full overflow-hidden flex items-center justify-center bg-white/5 border border-white/10 shrink-0">
              <img *ngIf="pool.logoUrl" [src]="pool.logoUrl" [alt]="pool.tokenName" class="w-full h-full object-cover">
              <span *ngIf="!pool.logoUrl" class="text-[11px] font-black text-white">{{ (pool.tokenName || '').charAt(0) || '?' }}</span>
            </div>
            <div>
              <p class="text-[13px] font-black text-white leading-none flex items-center gap-1.5">
                {{ pool.name }}
                <span *ngIf="pool.badge === 'Core'"
                  class="text-[8.5px] px-1.5 py-0.5 rounded bg-emerald-500/20 text-emerald-400 font-bold uppercase tracking-widest border border-emerald-500/20">Core</span>
              </p>
              <p class="text-[10.5px] text-text-dim mt-0.5">Staked: <span class="font-semibold text-white">${{
                  (pool.rawTotalStaked || 0).toLocaleString('en-US', { maximumFractionDigits: 0 }) }}</span></p>
            </div>
          </div>
          <div class="flex items-center gap-3">
            <div class="text-right">
              <p class="text-[9.5px] text-text-dim uppercase font-bold tracking-wider">APR</p>
              <p class="text-[14.5px] font-display font-black text-emerald-400">{{ pool.apy }}%</p>
            </div>
          </div>
        </div>
        }
        @empty {
        <div class="py-8 text-center text-sm font-bold text-text-muted italic">
          No Stacking Cockpit Record Found
        </div>
        }
      </div>
    </div>

  </div>
</section>
